import '../global.js';
import 'simplebar/dist/simplebar.css';
import 'jquery.marquee';

export const MobileNav = () => {
	var navopener = $('.nav-opener'),
		navwrap = $('.nav-slide'),
		links = navwrap.find('a'),
		navactive = 'nav-active',
		navout = 'nav-close';

	navopener.click(function () {
		$('body').toggleClass(navactive);

		if ($(this).hasClass('close')) {
			$('body').addClass(navout);
			setTimeout(() => {
				$('body').removeClass(navout);
			}, 1001);
		}
	});

	// add arrow icon to menu items
	const menuItems = document.querySelectorAll('.main-nav li > a');
	if (menuItems) {
		menuItems.forEach((item) => {
			item.insertAdjacentHTML('beforeend', '<i class="arrow-right"></i>');
		});
	}

	$('.main-nav li').each(function (i) {
		var item = $(this);
		var drop = item.find('ul');
		var link = item.find('a').eq(0);
		if (drop.length) {
			item.addClass('hasdrop');
			if (link.length)
				link
					.addClass('hasdrop-a')
					.attr({'data-more': '', 'data-outside': ''});
		}
		item[0].style = '--index:' + i
	});

	links.click(function () {
		$(this).hasClass('hasdrop-a') ? false : $('body').removeClass(navactive);
	});


	const navHeight = () => {
		const winH = window.innerHeight || document.documentElement.clientHeight;
		const nav = document.querySelector('.nav-slide');
		nav?.style.setProperty('height', winH + 'px');
	};

	navHeight();
	window.addEventListener('resize', navHeight);
};

export const OpenClose = () => {
	let touchHandled = false;

	const clickDataMoreHandler = function (e) {
		// Prevent double-firing on mobile (touch + click)
		if (touchHandled) {
			touchHandled = false;
			return;
		}

		e.preventDefault();
		$(this).hasClass('active')
			? $(this).removeClass('active')
			: $(this).addClass('active');
		$(this).next().stop().slideToggle(200);
	};

	const touchDataMoreHandler = function (e) {
		e.preventDefault();
		touchHandled = true;

		$(this).hasClass('active')
			? $(this).removeClass('active')
			: $(this).addClass('active');
		$(this).next().stop().slideToggle(200);

		// Reset flag after a short delay
		setTimeout(() => { touchHandled = false; }, 500);
	};

	const clickDataOutsideHandler = function (e) {
		$('[data-outside]').not(this).removeClass('active').next().slideUp(200);
	};

	const htmlClickHandler = function (e) {
		var target = $(e.target);

		if (
			!target.closest('[data-outside]').length &&
			!target.closest('[data-outside] + *').length
		) {
			setTimeout(function () {
				$('[data-outside]').removeClass('active').next().slideUp(200);
			}, 200);
		}
	};

	// Remove existing handlers
	$(document).off('click touchend', '[data-more]');
	$(document).off('click', '[data-outside]', clickDataOutsideHandler);
	$('html').off('click touchstart pointerdown MSPointerDown', htmlClickHandler);

	// Add new handlers
	$('[data-more]').next().hide();
	$('[data-more].active').next().show();

	$(this).hasClass('active')
		? $(this).removeClass('active')
		: $(this).addClass('active');

	$(document).on('click', '[data-more]', clickDataMoreHandler);
	$(document).on('touchend', '[data-more]', touchDataMoreHandler);
	$(document).on('click', '[data-outside]', clickDataOutsideHandler);
	$('html').on('click touchstart pointerdown MSPointerDown', htmlClickHandler);

	$('.block-holder').each(function() {
        var $holder = $(this);
        var $toggleLink = $holder.find('.block.drop-open');
        var $box = $holder.find('.lts-drop');

        $toggleLink.on('click', function (e) {
			e.preventDefault();
			$box.toggleClass('visible');
			$('body').toggleClass('drop-active', $box.hasClass('visible'));
			if ($(window).width() <= 768) {
				$('body').css('overflow', 'hidden');
			}
		});

		$('.modal-close-btn').on('click', function (e) {
			e.preventDefault();
			$box.removeClass('visible');
			$box.hide();
			$('.drop-open').removeClass('active');
			$('body').css('overflow', 'auto');
		});

        $(document).on('click', function(e) {
            if (!$holder.is(e.target) && $holder.has(e.target).length === 0) {
                if ($box.hasClass('visible')) {
                    $box.removeClass('visible');
                    $('body').removeClass('drop-active');
                }
            }
        });
    });
};

export const destroyOpenClose = () => {
	// Cleanup
	$(document).off('click touchend', '[data-more]');
	$(document).off('click', '[data-outside]');
	$('html').off('click touchstart pointerdown MSPointerDown');
};

export const HoverClassOnParent = (
	selector = '[data-accordion-trigger]',
	parent = '[data-accordion]'
) => {
	const item = document.querySelectorAll(selector);

	Array.from(item).forEach((el) => el.classList.remove('hover'));

	item.forEach((el) => {
		'mouseenter focusin'.split(' ').forEach((e) => {
			el.addEventListener(e, () => {
				el.closest(parent)?.classList.add('hover');
			});
		});

		'mouseout focusout'.split(' ').forEach((e) => {
			el.addEventListener(e, () => {
				el.closest(parent)?.classList.remove('hover');
			});
		});
	});
};

export const OpenCloseNew = () => {
	const firstAccordion = $('[data-accordion] [data-more]')[0];
	firstAccordion?.classList.add('active');
	$('[data-more]').next().hide();
	$('[data-more].active').next().show();
};

export const CustomSelect = () => {
	jQuery('[data-select]').each(function () {
		var item = jQuery(this),
			selectDrop = item.next(),
			linkItems = selectDrop.find('a');

		item.attr({'data-outside': '', 'data-more': ''});

		linkItems.on('click', function (e) {
			e.preventDefault();
			item.text(jQuery(this).text());
			selectDrop.slideUp(200);
			item.removeClass('active').addClass('selected');
			selectDrop.find('li').removeClass('active');
			jQuery(this).parent().addClass('active');
		});

		if (selectDrop.children().hasClass('active')) {
			item
				.text(jQuery(this).next().find('.active a').text())
				.addClass('selected');
		}
	});
};

export const Filter = () => {
	$('body')
		.find('[data-close]')
		.on('click', function (e) {
			e.preventDefault();
			//$('body').removeClass('filter--active');
			 enableScrollingOnIos(()=>{
			 	$('body').removeClass('filter--active');
			 });
		});
};

export const LinkBackBlog = () => {
	$('body')
		.find('[data-back-blog]')
		.on('click', function () {
			const url = new URL(window.location.href);
			const prev = new URL(document.referrer);

			window.location.replace(prev);
		});
};


export const BrowserOsClass = () => {
	// Get OS
	var os = ['iphone', 'ipad', 'windows', 'mac', 'linux'];

	var match = navigator.appVersion
		.toLowerCase()
		.match(new RegExp(os.join('|')));
	if (match) {
		$('body').addClass(match[0]);
	}
};

export const HomeHeroImages = (data) => {
	return new Promise((resolve, reject) => {
		try {
			let featuredSequences;
			const featuredSequencesElement =
				data.next.container.querySelector('#featuredSequences');

			if (featuredSequencesElement) {
				try {
					featuredSequences = JSON.parse(
						featuredSequencesElement.text
					);
					window.featuredSequences = featuredSequences;
				} catch (e) {
					console.error('Error parsing featuredSequences:', e);
				}
			}

			if (!featuredSequences || featuredSequences.length === 0) {
				const nextScripts =
					data.next.container.querySelectorAll('[data-script]');
				nextScripts.forEach((script) => {
					if (!script.src) {
						const newScript = document.createElement('script');
						newScript.innerHTML = script.innerHTML;
						document.body.appendChild(newScript);
					}
					script.remove();
				});

				return resolve(null);
			}

			let featuredImages;
			const hasSeenNewImages =
				localStorage.getItem('hasSeenNewImages') === 'true';

			if (!hasSeenNewImages) {
				featuredImages = featuredSequences[0];
				localStorage.setItem('hasSeenNewImages', 'true');
			} else {
				const showNewImages = Math.random() < 0.7;

				if (showNewImages) {
					featuredImages = featuredSequences[0];
				} else {
					featuredImages =
						featuredSequences[
							Math.floor(Math.random() * featuredSequences.length)
						];
				}
			}

			const bannerText = document.querySelector(
				'.banner-type-2 .banner-text'
			);
			if (!bannerText) {
				console.error('Banner text element not found');
				return resolve(null);
			}

			const imagesWidth = ['229', '209', '344'];
			const imagesGradient = ['yellow', 'blue', 'red'];
			const imagesSpeed = ['1', '3.2', '5.2'];

			const images = [
				featuredImages.vertical_image_1,
				featuredImages.vertical_image_2,
				featuredImages.horizontal_image,
			];

			const companyUrls = [
				featuredImages.company_1_url,
				featuredImages.company_2_url,
				featuredImages.company_3_url,
			];

			images.forEach((image, i) => {
				if (!image || !image.url) {
					console.warn(`Image ${i} is missing or has no URL`);
					return;
				}

				const imageContainer = document.createElement('div');
				imageContainer.setAttribute('data-content-parallax', '');
				imageContainer.setAttribute('data-speed', '1');
				imageContainer.setAttribute('data-scroll', '');
				imageContainer.setAttribute(
					'data-scroll-speed',
					imagesSpeed[i]
				);
				imageContainer.style.pointerEvents = 'none';

				const companyUrl = companyUrls[i];
				const imageTag = `<img src="${image.url}" alt="${image.alt || ''}" width="${
					imagesWidth[i]
				}">`;

				imageContainer.innerHTML = `
				<div class="img-banner img-0${i + 1}" data-home-slideIn>
					<div class="wrapper" data-sequence="1">
					<div data-select-effect class="${imagesGradient[i]}-gradient">
						${companyUrl ? `<a href="${companyUrl}" style="pointer-events: auto; position: relative; z-index: 2; display: block; height: 100%;">${imageTag}</a>` : imageTag}
					</div>
					</div>
				</div>
				`;

				bannerText.parentNode.insertBefore(imageContainer, bannerText);
			});

			resolve(featuredImages);
		} catch (error) {
			console.error('Error in HomeHeroImages:', error);
			reject(error);
		}
	});
};

export const setupWidthLinks = () => {
	const links = document.querySelectorAll('.link');
	links.forEach((link) => {
		link.style.width = link.offsetWidth + 20 + 'px';
	});
}

export const FactionModal = () => {
	const triggers = $('[href^="#modal-faction"]')

	if (!triggers.length) return

	triggers.each(function () {
		$(this).click(function (e) {
			e.preventDefault()
			$('body').addClass('modal-faction-active')
			$('#modal-faction').addClass('show')
			return false;
		})
	})

	$('#modal-faction .modal-close-btn, #modal-faction .btn').click(function (e) {
		$('body').removeClass('modal-faction-active')
		$('#modal-faction').removeClass('show')
	})
}

export class RemoveImageBackground {
	static instance = null;

	static create(containers) {
		if (!RemoveImageBackground.instance) {
			RemoveImageBackground.instance = new RemoveImageBackground(containers);
		}
		return RemoveImageBackground.instance;
	}

	constructor(containers) {

		if (typeof containers === 'object' && containers.length > 0) {
			this.init(containers);
		}

	}

	init(containers) {

		containers.forEach((container) => {
			const selectors = container.querySelectorAll('img');

			selectors.forEach((item) => {

				if (typeof item.src === 'string' && item.src.length > 0 && !item.src.endsWith('.svg')) {
					this.removeBackground(item.src).then((newSrc) => {
						item.src = newSrc
					})
				}

			});

		});
	}

	static destroy() {
		RemoveImageBackground.instance = null;
	}

	async removeBackground(image) {
		const backgroundColor = {red: 255, green: 255, blue: 255};
		const threshold = 10;

		const imageElement = new Image();
		imageElement.src = image;
		await new Promise(function (resolve) {
			imageElement.addEventListener('load', resolve);
		});

		const canvas = document.createElement('canvas');
		canvas.width = imageElement.naturalWidth;
		canvas.height = imageElement.naturalHeight;

		const ctx = canvas.getContext('2d');
		ctx.drawImage(imageElement, 0, 0);
		const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
		for (let i = 0; i < imageData.data.length; i += 4) {
			const red = imageData.data[i];
			const green = imageData.data[i + 1];
			const blue = imageData.data[i + 2];
			if (Math.abs(red - backgroundColor.red) < threshold &&
				Math.abs(green - backgroundColor.green) < threshold &&
				Math.abs(blue - backgroundColor.blue) < threshold) {
				imageData.data[i + 3] = 0;
			}
		}

		ctx.putImageData(imageData, 0, 0);
		return canvas.toDataURL(`image/png`);
	}

}

export const disableScrollingOnIos = (callback) => {
	if(callback) callback();
	setTimeout(() => {
		const body = document.querySelector('body');
		const filterWrap = document.querySelector('.filter-wrap');

		window.scroller.stop();
		window.filterScrollPosition = window.pageYOffset;
		body.style.overflow = 'hidden';
		body.style.position = 'fixed';
		body.style.top = `-${window.filterScrollPosition}px`;
		body.style.width = '100%';

		// Ensure filter wrap allows touch events
		if (filterWrap) {
			filterWrap.style.touchAction = 'auto';
			filterWrap.style.webkitTouchAction = 'auto';
		}
	}, 0);
}

export const enableScrollingOnIos = (callback) => {
	const scrollPosition = window.filterScrollPosition || 0;
	const body = document.querySelector('body');
	body.style.removeProperty('overflow');
	body.style.removeProperty('position');
	body.style.removeProperty('top');
	body.style.removeProperty('width');
	window.scrollTo(0, scrollPosition);

	if (typeof window.scroller !== 'undefined') {
		window.scroller.start();
	}

	setTimeout(() => {
		if(callback) callback();
	}, 0);
}

export const detectOperatingSystem= () => {
	const userAgent = navigator.userAgent.toLowerCase();

	if (userAgent.indexOf('mac') !== -1) {
		return 'Mac';
	} else if (userAgent.indexOf('win') !== -1) {
		return 'Windows';
	} else {
		return 'Unknown';
	}
}

export const ExternalLink = () => {
	let currentDomain = window.location.hostname;

	function isSameDomain(link) {
		let linkDomain = link.hostname;
		return linkDomain === currentDomain || linkDomain.includes('lsvp.com');
	}

	$('a').each(function () {
		var link = $(this);
		if (!isSameDomain(this)) {
			link.attr('target', '_blank');
		}
	});

	$('a:contains(http)').addClass('a-break')
};

export const Modal = () => {
	$('[data-modal]:not([href="#game-theory"])').on('click', function () {
		$('body').addClass('modal-active');
		$('.modal').removeClass('show');
		let targetModal = $($(this).attr('href'));
		targetModal.removeAttr('style').addClass('show');

		let vimeoIframe = targetModal.find('iframe[src*="vimeo.com"]');
		if (vimeoIframe.length) {
			let vimeoPlayer = new Vimeo.Player(vimeoIframe[0]);
			vimeoPlayer.play().catch(function (error) {
				console.error('Error playing Vimeo video:', error);
			});
		}

		return false;
	});

	jQuery('.modal .close').click(function (e) {
		e.preventDefault();
		const modal = $(this).closest('.modal');
		$('body').removeClass('modal-active');
		$('.modal').removeClass('show').removeClass('fadein');
		pauseAllVideos(modal);
		$('.nl-podcast--inner').css({
			'pointer-events': 'auto',
			'touch-action': 'auto',
			'position': 'relative',
			'z-index': '1'
		});
	});

	let modalCloseTimeout = null;
	let isModalClosing = false;

	const modalCloseHandler = function (e) {
		var target = jQuery(e.target);
		const activeModal = $('.modal.show');

		if (!activeModal.length) {
			return;
		}

		// Prevent multiple rapid events from triggering
		if (isModalClosing) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			return false;
		}

		const isVerticalScrollbarClick = (e) => {
			const rect = e.target.getBoundingClientRect();
			return (e.clientX > rect.left + rect.width - 20);
		};

		if (
			!target.closest('.modal-content').length &&
			!target.closest('.modal-content-holder').length &&
			!isVerticalScrollbarClick(e)
		) {
			// Prevent event from bubbling and triggering clicks on elements below the modal
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			isModalClosing = true;

			if (modalCloseTimeout) {
				clearTimeout(modalCloseTimeout);
			}

			modalCloseTimeout = setTimeout(() => {
				$('body').removeClass('modal-active');
				$('.modal').removeClass('show');
				if (activeModal.attr('id') !== 'video-modal') {
					pauseAllVideos(activeModal);
				}
				setTimeout(() => {
					$('.nl-podcast--inner').css({
						'pointer-events': 'auto',
						'touch-action': 'auto',
						'position': 'relative',
						'z-index': '1'
					});
					isModalClosing = false;
				}, 100);
			}, 50);

			return false;
		}
	};

	document.documentElement.addEventListener('click', modalCloseHandler, false);
	document.documentElement.addEventListener('touchstart', modalCloseHandler, {passive: false});
	document.documentElement.addEventListener('pointerdown', modalCloseHandler, {passive: false});
	document.documentElement.addEventListener('MSPointerDown', modalCloseHandler, {passive: false});

	function pauseAllVideos(modal, game_theory) {
		var videos = document.querySelectorAll('video:not(.background):not(.game-theory-video)');
		var iframes = document.querySelectorAll('iframe');
		let src = '';

		videos.forEach(function (video) {
			if (!video.paused) {
				video.pause();
			}
		});

		if (modal) {
			modal.find('iframe').each(function () {
				const iframe = this;
				src = iframe.getAttribute('src');
				iframe.removeAttribute('src');
				iframe.setAttribute('src', src);
			});
		} else {
			iframes.forEach(function (iframe) {
				src = iframe.getAttribute('src');
				iframe.removeAttribute('src');
				iframe.setAttribute('src', src);
			});
		}
	}
};

export const firstSlideCaption = () => {
	$(document).ready(function () {
		let activeSlide = $('.swiper-slide-active');
		let caption = activeSlide.data('caption');
		let linkSlide = activeSlide.data('url');
		$('.img-caption').text(caption);
		if (linkSlide){
			$('.img-caption').attr('href', linkSlide);
		} else {
			$('.img-caption').removeAttr('href');
		}

		let activeSlideModal = $('.image-slider-modal .swiper-slide-active');
		let captionModal = activeSlideModal.data('caption');
		let linkModal = activeSlideModal.data('url');
		$('.img-caption-modal').text(captionModal);
		if (linkModal) {
			$('.img-caption-modal').attr('href', linkModal);
		} else {
			$('.img-caption-modal').removeAttr('href');
		}
	});
};

export const classOnLoad = () => {
	let items = document.querySelectorAll('[data-class-on-load]');
	items.forEach((item) => {
		if (item.dataset.classOnLoad && item.dataset.classOnLoad.length > 0) {
			item.classList.add(item.dataset.classOnLoad);
		}
	});
}


export const playVideoOnScroll = () => {
	$(document).ready(function () {
		let players = [];
		$('.vimeo-video').each(function () {
			const iframe = $(this).find('iframe').get(0);
			const player = new Vimeo.Player(iframe);
			let manuallyPaused = false;

			player.on('pause', () => {
				manuallyPaused = true;
			});

			player.on('play', () => {
				manuallyPaused = false;
			});

			players.push({
				player,
				top: $(this).position().top,
				height: $(this).outerHeight(),
				status: 'paused',
				manuallyPaused: () => manuallyPaused
			});
		});

		let viewportHeight = $(window).height();

		scroller.on('scroll', function (position) {
			var scrollPos = position.scroll.y;
			for (var i = 0; i < players.length; i++) {
				var elementTop = players[i].top;
				var elementBottom = elementTop + players[i].height;

				var inViewport =
					scrollPos + viewportHeight > elementTop &&
					scrollPos < elementBottom;

				if (inViewport && players[i].status !== 'play' && !players[i].manuallyPaused()) {
					players[i].status = 'play';
					players[i].player.play();
				}
			}
		});
	});
};


export const TreeTabs = () => {
	$('[data-tab]').click(function (e) {
		e.preventDefault();
		var tab_id = $(this).attr('data-tab');
		$(this).parent().siblings().find('[data-tab]').removeClass('active');
		$('#' + tab_id)
			.siblings()
			.fadeOut(310);
		$(this).addClass('active');
		setTimeout(function () {
			$('#' + tab_id).fadeIn(300);
		}, 305);
	});
	$('#' + $('[data-tab].active').data('tab')).addClass('active');
};


export const Marquee = () => {
    const marqueeLeft = () => {
        const marqueeLeft = $('[data-marquee-left]').marquee({
            speed: 40,
            gap: 66,
            delayBeforeStart: 0,
            direction: 'left',
            duplicated: true,
            duplicateCount: 4,
            pauseOnHover: false,
            startVisible: true,
        });

			const marqueeRight = $('[data-marquee-right]').marquee({
				speed: 40,
				gap: 66,
				delayBeforeStart: 0,
				direction: 'right',
				duplicated: true,
				duplicateCount: 4,
				pauseOnHover: false,
				startVisible: true,
			});
    }

	const marqueeLeft2 = () => {
		const marqueeLeft2 = $('[data-marquee-left-2]').marquee({
			speed: 40,
			gap: 66,
			delayBeforeStart: 0,
			direction: 'left',
			duplicated: true,
			duplicateCount: 4,
			pauseOnHover: false,
			startVisible: true,
		});
	};

    marqueeLeft();
	marqueeLeft2();
}
export const ImageWidth = () => {
	$('[data-width]').each(function() {
		let item = $(this)
		const widths = item.data('width').split(',')
		const reload = () => {
			if($(window).width() >= 1280) {
				item.width(parseInt(widths[0]))
			} else if ($(window).width() < 1280 && $(window).width() >= 1024) {
				item.width(parseInt(widths[1]))
			} else if ($(window).width() < 1024) {
				item.width(parseInt(widths[2]))
			}
		}

		reload()
		$(window).on('resize', reload)
	});
}

const videosData = window.videosData || [];


export const extractYoutubeData = () => {

    // Function to format view counts
   function formatViewCount(count) {
        if (count >= 1000000) {
            return (count / 1000000).toFixed(1) + 'M views';
        } else if (count >= 1000) {
            return (count / 1000).toFixed(1) + 'K views';
        } else {
            return count + ' views';
        }
    }

    // API Key for YouTube Data API
    const API_KEY = 'AIzaSyBL_rLVlJvDQq7JDjW_dtN2KpGpd_r8Dw0';
    const DEFAULT_CHANNEL_ICON = '/wp-content/themes/lsvp/assets/images/default-channel-icon.jpg';

    // Process thumbnail images
    $('.thumbnail-image').each(function() {
        const $imageElement = $(this);
        const videoId = $imageElement.attr('data-video-id');

        // Skip if this specific element has already been touched for image purposes
        if ($imageElement.hasClass('youtube-image-processed')) {
            return;
        }
        $imageElement.addClass('youtube-image-processed');

        // Always show default channel icon regardless of videoId
        $imageElement.html(`
            <div class="channel-icon">
                <img src="${DEFAULT_CHANNEL_ICON}" alt="LSVP">
            </div>
        `);
    });

    // Process view counts separately
    $('.thumbnail-guest.views').each(function() {
        const $viewsElement = $(this);
        const videoId = $viewsElement.attr('data-video-id');

        // Skip if this specific element has already been touched for views purposes
        if ($viewsElement.hasClass('youtube-views-processed')) {
            return;
        }
        $viewsElement.addClass('youtube-views-processed');


        if (!videoId || videoId === '$video_id' || videoId.trim() === '') {
            // If videoId is missing, or is the placeholder, or empty string
            $viewsElement.text(''); // Or 'Views N/A' or hide
        } else {
            // Valid videoId, fetch view count
            $viewsElement.text('Loading views...');
            $.ajax({
                url: 'https://www.googleapis.com/youtube/v3/videos',
                data: { part: 'statistics', id: videoId, key: API_KEY },
                dataType: 'json',
                success: function(data) {
                    if (data.items && data.items.length > 0) {
                        const viewCount = parseInt(data.items[0].statistics.viewCount);
                        const formattedCount = formatViewCount(viewCount);
                        $viewsElement.text(formattedCount);
                    } else {
                        $viewsElement.text('Views not available');
                    }
                },
                error: function(error) {
                    console.error('Error fetching video stats for views:', error);
                    $viewsElement.text('Unable to load views');
                }
            });
        }
    });
};

export const LsipModal = () => {
	const modal = document.querySelector('#modal-lsip');
	if (!modal) return;
	
	const expectedReferrer = modal.getAttribute('data-referrer');
	if (!expectedReferrer) return;
	
	let savedHref = null;
	let isModalOpening = false;
	
	const checkDomainMatch = (href) => {
		try {
			if (!href) return false;
			
			let cleanHref = href;
			if (cleanHref.startsWith('@')) {
				cleanHref = cleanHref.substring(1);
			}
			
			// Handle relative URLs by converting to absolute
			if (!cleanHref.match(/^https?:\/\//)) {
				// If it's a relative URL, make it absolute using current origin
				if (cleanHref.startsWith('/')) {
					cleanHref = window.location.origin + cleanHref;
				} else {
					cleanHref = 'https://' + cleanHref;
				}
			}
			
			let cleanExpectedReferrer = expectedReferrer;
			if (cleanExpectedReferrer.startsWith('@')) {
				cleanExpectedReferrer = cleanExpectedReferrer.substring(1);
			}
			
			if (!cleanExpectedReferrer.match(/^https?:\/\//)) {
				cleanExpectedReferrer = 'https://' + cleanExpectedReferrer;
			}
			
			const hrefUrl = new URL(cleanHref);
			const expectedUrl = new URL(cleanExpectedReferrer);
			
			const hrefDomain = hrefUrl.hostname;
			const expectedDomain = expectedUrl.hostname;
			
			const exactMatch = hrefDomain === expectedDomain;
			const subdomainMatch = hrefDomain.endsWith('.' + expectedDomain);
			const parentDomainMatch = expectedDomain.endsWith('.' + hrefDomain);
			
			return exactMatch || subdomainMatch || parentDomainMatch;
		} catch (error) {
			return false;
		}
	};
	
	const showModal = () => {
		isModalOpening = true;
		$('body').addClass('modal-lsip-active');
		$('#modal-lsip').addClass('show');
		updateButtonHref();
		
		setTimeout(() => {
			isModalOpening = false;
		}, 100);
	};
	
	const hideModal = () => {
		$('body').removeClass('modal-lsip-active');
		$('#modal-lsip').removeClass('show');
		savedHref = null;
		updateButtonHref();
	};
	
	// Helper functions for "Don't show again" functionality with 1-day expiration
	const shouldSkipModal = (localStorageKey) => {
		const saved = localStorage.getItem(localStorageKey);
		if (!saved) {
			return false;
		}
		
		try {
			const data = JSON.parse(saved);
			const now = Date.now();
			const oneDayInMs = 24 * 60 * 60 * 1000; // 1 day in milliseconds
			
			// Check if 1 day has passed
			if (now - data.timestamp < oneDayInMs) {
				return true; // Still within 1 day, skip the modal
			} else {
				// More than 1 day has passed, remove the saved preference
				localStorage.removeItem(localStorageKey);
				return false;
			}
		} catch (e) {
			// If parsing fails, remove invalid data
			localStorage.removeItem(localStorageKey);
			return false;
		}
	};
	
	const saveDontShowAgain = (localStorageKey) => {
		const data = {
			timestamp: Date.now()
		};
		localStorage.setItem(localStorageKey, JSON.stringify(data));
	};
	
	const showTeamModal = () => {
		// Check if modal should be skipped
		if (shouldSkipModal('modal-team-dont-show-again')) {
			// Skip showing modal, proceed with the link
			if (savedHref) {
				window.location.href = savedHref;
			}
			return;
		}
		
		isModalOpening = true;
		$('body').addClass('modal-active');
		$('#modal-team').addClass('show');
		updateTeamButtonHref();
		
		setTimeout(() => {
			isModalOpening = false;
		}, 100);
	};
	
	const hideTeamModal = () => {
		$('body').removeClass('modal-active');
		$('#modal-team').removeClass('show');
		savedHref = null;
		updateTeamButtonHref();
	};
	
	const showFilterModal = () => {
		// Check if modal should be skipped
		if (shouldSkipModal('modal-filter-dont-show-again')) {
			// Skip showing modal, proceed with the link
			if (savedHref) {
				window.location.href = savedHref;
			}
			return;
		}
		
		isModalOpening = true;
		$('body').addClass('modal-active');
		$('#modal-filter').addClass('show');
		updateFilterButtonHref();
		
		setTimeout(() => {
			isModalOpening = false;
		}, 100);
	};
	
	const hideFilterModal = () => {
		$('body').removeClass('modal-active');
		$('#modal-filter').removeClass('show');
		savedHref = null;
		updateFilterButtonHref();
	};
	
	// Handle team member links specifically (from team filter)
	// For team members, show modal-team instead of modal-lsip
	// Don't show modal if team member has LSIP firm
	$(document).on('click', 'a.teamcard[href]', function (e) {
		const link = $(this);
		const href = link.attr('href');
		const firm = link.attr('data-firm');
		
		if (link.closest('#modal-team, #modal-lsip').length) {
			return;
		}
		
		// Skip modal if element has disable-modal attribute or class
		if (link.attr('disable-modal') !== undefined || 
			link.attr('data-disable-modal') !== undefined ||
			link.hasClass('disable-modal-link') ||
			link.parent().hasClass('disable-modal-link')) {
			return;
		}
		
		// Don't show modal if team member has LSIP firm
		if (firm === 'lsip') {
			return;
		}
		
		// Check if the team member URL contains the referrer domain
		if (checkDomainMatch(href)) {
			e.preventDefault();
			savedHref = href;
			
			setTimeout(() => {
				showTeamModal();
			}, 10);
		}
	});
	
	// Handle LSVP company links - show modal-filter instead of modal-lsip
	$(document).on('click', 'a.teamcard[data-investor="lsvp"]', function (e) {
		const link = $(this);
		const href = link.attr('href');
		
		if (link.closest('#modal-filter, #modal-lsip, #modal-team').length) {
			return;
		}
		
		// Skip modal if element has disable-modal attribute or class
		if (link.attr('disable-modal') !== undefined || 
			link.attr('data-disable-modal') !== undefined ||
			link.hasClass('disable-modal-link') ||
			link.parent().hasClass('disable-modal-link')) {
			return;
		}
		
		// Check if the company URL contains the referrer domain
		if (checkDomainMatch(href)) {
			e.preventDefault();
			savedHref = href;
			
			setTimeout(() => {
				showFilterModal();
			}, 10);
		}
	});
	
	// Handle company links (with data-company-link attribute) - show modal-filter for all companies with referrer
	$(document).on('click', 'a[data-company-link="true"]', function (e) {
		const link = $(this);
		const href = link.attr('href');
		
		if (link.closest('#modal-filter, #modal-lsip, #modal-team').length) {
			return;
		}
		
		// Skip modal if element has disable-modal attribute or class
		if (link.attr('disable-modal') !== undefined || 
			link.attr('data-disable-modal') !== undefined ||
			link.hasClass('disable-modal-link') ||
			link.parent().hasClass('disable-modal-link')) {
			return;
		}
		
		// Check if the company URL contains the referrer domain
		if (checkDomainMatch(href)) {
			e.preventDefault();
			savedHref = href;
			
			setTimeout(() => {
				showFilterModal();
			}, 10);
		}
	});
	
	// Handle other links (non-team member, non-company links) - keep original behavior
	$(document).on('click', 'a[href]:not(.teamcard):not([data-company-link="true"])', function (e) {
		const link = $(this);
		const href = link.attr('href');
		
		if (link.closest('#modal-lsip').length) {
			return;
		}
		
		// Skip modal if element has disable-modal attribute or class
		if (link.attr('disable-modal') !== undefined || 
			link.attr('data-disable-modal') !== undefined ||
			link.hasClass('disable-modal-link') ||
			link.parent().hasClass('disable-modal-link')) {
			return;
		}
		
		if (checkDomainMatch(href)) {
			e.preventDefault();
			savedHref = href;
			
			setTimeout(() => {
				showModal();
			}, 10);
		}
	});
	
	$('#modal-lsip .btn').click(function (e) {
		e.preventDefault();
		
		if (savedHref) {
			window.location.href = savedHref;
		}
		
		hideModal();
	});
	
	// Update button href when modal is shown
	const updateButtonHref = () => {
		const btn = $('#modal-lsip .btn');
		if (savedHref) {
			btn.attr('href', savedHref);
		} else {
			btn.removeAttr('href');
		}
	};
	
	const updateTeamButtonHref = () => {
		const btn = $('#modal-team .btn');
		if (savedHref) {
			btn.attr('href', savedHref);
		} else {
			btn.removeAttr('href');
		}
	};
	
	const updateFilterButtonHref = () => {
		const btn = $('#modal-filter .btn');
		if (savedHref) {
			btn.attr('href', savedHref);
		} else {
			btn.removeAttr('href');
		}
	};
	
	// Handle modal-team button click
	$('#modal-team .btn').click(function (e) {
		e.preventDefault();
		
		// Check if "don't show again" checkbox is checked before navigating
		const dontShowAgain = $('#modal-team-dont-show-again').is(':checked');
		if (dontShowAgain) {
			saveDontShowAgain('modal-team-dont-show-again');
		}
		
		if (savedHref) {
			window.location.href = savedHref;
		}
		
		hideTeamModal();
	});
	
	// Handle modal-filter button click
	$('#modal-filter .btn').click(function (e) {
		e.preventDefault();
		
		// Check if "don't show again" checkbox is checked before navigating
		const dontShowAgain = $('#modal-filter-dont-show-again').is(':checked');
		if (dontShowAgain) {
			saveDontShowAgain('modal-filter-dont-show-again');
		}
		
		if (savedHref) {
			window.location.href = savedHref;
		}
		
		hideFilterModal();
	});
	
	$('#modal-lsip .modal-close-btn').click(function (e) {
		e.preventDefault();
		hideModal();
	});
	
	$('#modal-team .modal-close-btn').click(function (e) {
		e.preventDefault();
		hideTeamModal();
	});
	
	$('#modal-filter .modal-close-btn').click(function (e) {
		e.preventDefault();
		hideFilterModal();
	});
	
	// Prevent clicks inside modal-box from closing the modal
	$('#modal-lsip .modal-box').click(function (e) {
		e.stopPropagation();
	});
	
	$('#modal-team .modal-box').click(function (e) {
		e.stopPropagation();
	});
	
	$('#modal-filter .modal-box').click(function (e) {
		e.stopPropagation();
	});
	
	// Close modal when clicking outside (on backdrop)
	$('#modal-lsip').click(function (e) {
		if (isModalOpening) {
			return;
		}
		// Check if click is on modal backdrop (not inside modal-box)
		if (!$(e.target).closest('.modal-box').length) {
			hideModal();
		}
	});
	
	$('#modal-team').click(function (e) {
		if (isModalOpening) {
			return;
		}
		// Check if click is on modal backdrop (not inside modal-box)
		if (!$(e.target).closest('.modal-box').length) {
			hideTeamModal();
		}
	});
	
	$('#modal-filter').click(function (e) {
		if (isModalOpening) {
			return;
		}
		// Check if click is on modal backdrop (not inside modal-box)
		if (!$(e.target).closest('.modal-box').length) {
			hideFilterModal();
		}
	});
};